import { useState } from "react";
import type { OrderConfirmationChoice } from "../../domain/order-confirmation";
type Scope = { isCurrent: () => boolean; };
type Draft = {
  choice: OrderConfirmationChoice;
  reason: string;
  date: string;
  quantity: string;
  note: string;
};
const empty = (): Draft => ({
  choice: "ACCEPTED",
  reason: "",
  date: "",
  quantity: "",
  note: ""
});
export function useOrderConfirmationDraft(scope: Scope) {
  const [stored, setStored] = useState(() => ({ scope, draft: empty() }));
  const draft = stored.scope === scope ? stored.draft : empty();
  const update = <K extends keyof Draft>(field: K, value: Draft[K]) => {
    if (!scope.isCurrent()) return;
    setStored(previous => ({ scope, draft: { ...(previous.scope === scope ? previous.draft : empty()), [field]: value } }));
  };
  return {
    ...draft,
    setChoice: (value: OrderConfirmationChoice) => update("choice", value),
    setReason: (value: string) => update("reason", value),
    setDate: (value: string) => update("date", value),
    setQuantity: (value: string) => update("quantity", value),
    setNote: (value: string) => update("note", value)
  };
}
